import ObjectUtil from "../../core/internal/util/ObjectUtil"
import HackleCore from "../../core/HackleCore"
import { UserManager } from "../../core/internal/user/UserManager"

type GlobalErrorHandlerKey = "onerror" | "onunhandledrejection"
type Installation = (core: HackleCore, userManager: UserManager) => void

export class GlobalErrorHandler {
  private _installed: Array<GlobalErrorHandlerKey> = []
  private _installations: Record<GlobalErrorHandlerKey, Installation> = {
    onerror: _installOnError,
    onunhandledrejection: _installOnUnhandledRejection
  }

  install(core: HackleCore, userManager: UserManager) {
    this._install("onerror", core, userManager)
    this._install("onunhandledrejection", core, userManager)
  }

  _install(key: GlobalErrorHandlerKey, core: HackleCore, userManager: UserManager) {
    if (key in this._installed) {
      return
    }
    const install = this._installations[key]
    install(core, userManager)
    this._installed.push(key)
  }
}

let _oldOnErrorEventHandler: OnErrorEventHandler = null

function _installOnError(core: HackleCore, userManager: UserManager) {
  _oldOnErrorEventHandler = window.onerror
  window.onerror = function (msg: any, url: any, line: any, column: any, error: any) {
    if (ObjectUtil.isNotNullOrUndefined(error)) {
      core.trackException(error, userManager.hackleUser())
    }

    if (_oldOnErrorEventHandler) {
      // @ts-ignore
      _oldOnErrorEventHandler.apply(this, arguments)
    }
  }
}

let _oldOnUnhandledRejectionEventHandler: ((this: WindowEventHandlers, ev: PromiseRejectionEvent) => any) | null

function _installOnUnhandledRejection(core: HackleCore, userManager: UserManager) {
  _oldOnUnhandledRejectionEventHandler = window.onunhandledrejection
  window.onunhandledrejection = function (e: any) {
    let error
    try {
      if ("reason" in e) {
        error = e.reason
      } else if ("detail" in e && "reason" in e.detail) {
        error = e.detail.reason
      }
    } catch (_) {
      // ignore
    }

    if (error instanceof Error) {
      core.trackException(error, userManager.hackleUser())
    }

    if (_oldOnUnhandledRejectionEventHandler) {
      // @ts-ignore
      _oldOnUnhandledRejectionEventHandler.apply(this, arguments)
    }
  }
}
